import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import { WrapperSection } from '../../wrappers'
import { Grid } from '@material-ui/core'
import { s, colors, alpha } from '../../style'
import { T } from '../../typo'
import FlashOnIcon from '@material-ui/icons/FlashOn'
import Img from 'gatsby-image'

const CommonServices = ({ data, theme }) => {
  const results = useStaticQuery(graphql`
    {
      phones: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/content/phones/" } }
        sort: { fields: [frontmatter___order], order: ASC }
      ) {
        edges {
          node {
            frontmatter {
              language
              title
              order
              product_slug
              list_string {
                title
              }
              image {
                name
                childImageSharp {
                  fluid(
                    maxWidth: 400
                    quality: 100
                    toFormat: WEBP
                    fit: CONTAIN
                  ) {
                    ...GatsbyImageSharpFluid_tracedSVG
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const phones = results.phones.edges.map(({ node }) => node.frontmatter)

  // console.log(phones)

  return (
    <WrapperSection
      id={data.slug_section}
      extraCss={{ [s.md]: { marginTop: 0 } }}>
      <T
        d={32}
        m={24}
        mb={2}
        variant={'h2'}
        upper
        spacious
        o={0.3}
        bold
        center
        extraCss={{ padding: '0 1rem' }}>
        Najczęstsze usterki smartfonów
      </T>

      <Grid
        container
        css={{ [s.xs]: { padding: '0 0.5rem' }, alignItems: 'stretch' }}>
        {phones.map((phone, id) => (
          <Grid item xs={6} sm={6} md={4} lg={3} key={id} css={sContainerOuter}>
            <Link to={`/${phone.product_slug}`} css={sContainerInner(theme)}>
              <div>
                <div css={{ [s.sm]: { height: 300 }, [s.xs]: { height: 160 } }}>
                  <Img
                    className="commonservices-image"
                    style={{ height: '100%' }}
                    imgStyle={{ objectFit: 'contain' }}
                    fluid={phone.image?.childImageSharp?.fluid}
                    alt={phone.title}
                  />
                </div>
                <div>
                  <T
                    variant="h4"
                    m={16}
                    d={20}
                    bold
                    center
                    extraCss={{
                      paddingBottom: '1.5rem',
                      [s.xs]: { paddingTop: '1rem' },
                    }}
                    className="commonservices-title">
                    {phone.title}
                  </T>
                  <div>
                    {phone.list_string?.map(({ title }, id) => (
                      <div key={id} css={sBullet}>
                        <FlashOnIcon fontSize="small" />
                        <T
                          m={12}
                          d={14}
                          extraCss={{ lineHeight: '1.3em' }}
                          variant="h5">
                          {title}
                        </T>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <T
                m={13}
                d={14}
                spacious
                center
                upper
                bold
                mt={2}
                className="commonservices-link"
                extraCss={{ color: colors[theme].main }}>
                Sprawdź
              </T>
            </Link>
          </Grid>
        ))}
      </Grid>
    </WrapperSection>
  )
}

const sContainerOuter = {
  [s.sm_down]: {
    padding: 0,
  },
  [s.sm_only]: {
    padding: '1rem',
  },
  [s.md]: {
    padding: '1rem',
  },
}

const sContainerInner = (theme) => ({
  '&, .commonservices-image': { transition: 'transform 0.25s ease-out' },
  '.commonservices-title': {
    transition: 'transform 0.25s ease-out 0.125s, color 0.25s ease-in-out',
  },
  background: `linear-gradient(to bottom right, ${colors[
    theme
  ].container.concat(alpha[0])} 10%, ${colors[theme].container})`,
  padding: '2rem 1rem 2rem',
  [s.xs]: { padding: '1rem 0.5rem 1rem' },
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  borderRadius: '1rem',
  '.commonservices-link': {
    transition: 'opacity 0.25s ease-in, letter-spacing 0.25s ease-in',
    opacity: 0.3,
  },
  '&:hover': {
    [s.hover]: {
      transform: 'scale(1.05)',
      '.commonservices-image': {
        transform: 'scale(1.1)',
      },
      '.commonservices-title': {
        transform: 'scale(1.1)',
        color: colors[theme].main,
      },
      '.commonservices-link': {
        opacity: 1,
        letterSpacing: '0.4em',
      },
    },
  },
})

const sBullet = {
  opacity: 0.6,
  display: 'flex',
  flexDiection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  [s.xs]: {
    marginBottom: '0.25rem',
    svg: {
      width: 12,
    },
  },
  [s.md]: {
    marginBottom: '0.5rem',
  },
  svg: {
    marginRight: '0.5rem',
    opacity: 0.5,
  },
}

export default CommonServices
